import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'

export const defaultText = {
  question: 'On a scale from 1 - 10, how likely are you to recommend our service to a friend?',
  startLabel: 'Not very likely',
  endLabel: 'Extremely likely',
}

export const defaultSettings = {
  type: BLOCK_TYPES.FIELD,
  fieldType: FIELD_TYPES.SCALE,
  question: defaultText.question,
  isRequired: false,
  startLabel: defaultText.startLabel,
  endLabel: defaultText.endLabel,
}
